import sleep from '@anm/helpers/sleep';
import { Features } from '@anm/shared/features';

type AsyncRequest<T> = () => Promise<T>;

const uploadQueue = async <T>(requests: AsyncRequest<T>[], iterateBy = Features.multipartUpload.chunksByIteration) => {
  let counter = 0;

  const run = async <T>(task: AsyncRequest<T>): Promise<T> => {
    if (counter > iterateBy - 1) {
      await sleep(100);
      return run(task);
    }

    counter += 1;

    return task()
      .catch(() => {})
      .finally(() => (counter -= 1)) as Promise<T>;
  };

  const promises = requests.map(run);

  return Promise.all(promises);
};

export default uploadQueue;
